import { authHeader, noUserPostHeader  } from '../_helpers';
import axios from 'axios'

var CONFIG_SIZER_NODEJS_API_URL = process.env.REACT_APP_CONFIG_SIZER_NODEJS_API_URL;

var serviceUtils  = require ('./ServicesUtils');
const baseUrl = CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/';

export const clientApiService = {
    createScannedUser,
    updateAdditionalFields,
    scanCompleted,
    shareClient,
    checkProductStatus,
    userStatus,
    runTest,
    reportClientActivity,
    uploadScanData,
    getCompanyConfigJson,
    getClientConfigJson,
    validateClientSharingCode,
    getDeviceConfiguration,
    webscan_getScanSessionStatus,
    webscan_getScanSessionData,
    webscan_updateScanSession,
    webscan_createScanSession
};
 
function webscan_getScanSessionData(sessionid) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/webscan_getScanSessionData?sessionid='+sessionid,requestOptions).then(handleResponse);
}

function webscan_getScanSessionStatus(sessionid) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/webscan_getScanSessionStatus?sessionid='+sessionid,requestOptions).then(handleResponse);
}


function webscan_createScanSession(sessionid,clientid='',lang='',theme='',garmentid='',widgetConfigJson='', endOfScan='') {
    const requestOptions = {
        method: 'POST',
        headers: noUserPostHeader(),
        body: JSON.stringify({sessionid,clientid,lang,theme,garmentid,widgetConfigJson, endOfScan})
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/webscan_createScanSession',
     requestOptions).then(handleResponse);	
//     return serviceUtils.POST(baseUrl+'webscan_createScanSession',params).then(serviceUtils.RESPONSE);
}

function webscan_updateScanSession(sessionid,userid,status) {
    const requestOptions = {
        method: 'POST',
        headers: noUserPostHeader(),
        body: JSON.stringify({sessionid,userid,status})
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/webscan_updateScanSession',
     requestOptions).then(handleResponse);	
//    return serviceUtils.POST(baseUrl+'webscan_updateScanSession',params).then(serviceUtils.RESPONSE);
}

function getDeviceConfiguration(params) {
    return serviceUtils.GET(baseUrl+'getDeviceConfiguration',params).then(serviceUtils.RESPONSE);	
}

function updateAdditionalFields(params){
    return serviceUtils.POST(baseUrl+'updateAdditionalFields',params).then(serviceUtils.RESPONSE);
}

function uploadScanData(deviceId, scanId, userid, body, config) {
    // return serviceUtils.POST(baseUrl+'uploadScanData?deviceId='+deviceId+"&scanId"+scanId,scanData).then(serviceUtils.RESPONSE);
    // axios.create({baseUrldeviceId=${deviceId}&scanId=${scanId}`, body, config})
    axios.post(`${baseUrl}uploadScanData?deviceId=${deviceId}&scanId=${scanId}&userid=${userid}`, body, config)
}

function createScannedUser(
    name, email, gender, height, clientId, 
    locale, language, platform, additionalFieldsJson, userid='',weight=0,
    firstName='', lastName='',allowUserUpdates=false, userDeviceInfo='', preferred_size
    ) {
    const requestOptions = {
        method: 'POST',
        headers: noUserPostHeader(),
        body: JSON.stringify({name, email, gender, height,clientId, locale, language, platform, additionalFieldsJson, userid,weight, firstName, lastName, allowUserUpdates,userDeviceInfo,preferred_size})
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/createScannedUser',
     requestOptions).then(handleResponse);	
}

function scanCompleted(userId, manualFolder) {
    const requestOptions = {
        method: 'POST',
        headers: noUserPostHeader(),
        body: JSON.stringify({userId, manualFolder})
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/scanCompleted',
     requestOptions).then(handleResponse);	
}

function shareClient(userid, sharingCode) {
    const requestOptions = {
        method: 'POST',
        headers: noUserPostHeader(),
        body: JSON.stringify({userid, sharingCode})
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/shareClient',
     requestOptions).then(handleResponse);	
}


function userStatus(email,userId='',sharingCode='', widgetURL='', recommendationMethod='', clientid='') {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/userStatus?email='+email+'&userId='+userId+'&sharingCode='+sharingCode+'&widgetURL='+widgetURL+'&recommendationMethod='+recommendationMethod+'&clientid='+clientid,requestOptions).then(handleResponse);
}

function checkProductStatus(widgetURL='',clientid='') {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/checkProductStatus?widgetURL='+widgetURL+'&clientid='+clientid,requestOptions).then(handleResponse);
}


function runTest(testid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/runTest?testid='+testid,requestOptions).then(handleResponse);
}

function reportClientActivity(message) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/reportClientActivity?message='+message,requestOptions).then(handleResponse);
}

function getCompanyConfigJson(scanningCompanyId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/getCompanyConfigJson?scanningCompanyId='+scanningCompanyId,requestOptions).then(handleResponse);
}

function getClientConfigJson(clientid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/getClientConfigJson?clientid='+clientid,requestOptions).then(handleResponse);
}

function validateClientSharingCode(sharingCode) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(CONFIG_SIZER_NODEJS_API_URL+'/api/v1/client/validateClientSharingCode?sharingCode='+sharingCode,requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
//                logout(); //MOTI!!
  //              location.reload(true);//MOTI!!
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}